var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VButton",
    {
      class: [
        "bigger-video-preview-button",
        _vm.btnClass,
        { "bigger-video-preview-button-show": _vm.enlarged },
      ],
      staticStyle: { padding: "0" },
      on: { click: _vm.onClick },
    },
    [
      _c("VIcon", {
        attrs: {
          icon: _vm.enlarged ? "mdi-magnify-minus" : "mdi-magnify-plus",
          size: 16,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }